import { FormErrors } from 'common-front/src/components/form/formErrors';
import Alert from 'common-front/src/designSystem/components/alert';
import { Button } from 'common-front/src/designSystem/components/button';
import { Flex } from 'common/src/designSystem/components/flex';
import { styled } from 'common/src/designSystem/components/stitches';
import { useParams, useTranslate } from 'common/src/util/dependencies/dependencies';
import { HeaventPaths } from 'common/src/util/paths/heaventPaths';
import * as React from 'react';
import { AccreditationsBox } from './boxes/accreditationsBox';
import { CommunicationBox, CommunicationSkeletonBox } from './boxes/communicationBox';
import { DelegationsBox } from './boxes/delegationsBox';
import { InformationBox, InformationSkeletonBox } from './boxes/informationBox';
import { MembersBox, MembersSkeletonBox } from './boxes/membersBox';
import { PositionsBox, PositionsSkeletonBox } from './boxes/positionsBox';

const InlineButton = styled('span', {
    '& a': { display: 'inline-flex !important' }
});

export const RoleForm = ({
    children,
    disabled = false
}: {
    children: React.ReactNode;
    disabled?: boolean;
}) => {
    const translate = useTranslate();
    const { organizationId, roleId } = useParams();

    return (
        <Flex direction="column" gap="4">
            <FormErrors />
            {disabled && (
                <Alert.Root color="warning">
                    <Alert.Titled>
                        <Alert.Title icon="circle-exclamation">
                            {translate('impossible_de_m_46897')}
                        </Alert.Title>
                        <Alert.Text>
                            {`${translate('ce_r_le_est_pr_71742')} `}
                            <InlineButton>
                                <Button
                                    color="white"
                                    size="sm"
                                    to={HeaventPaths.DUPLICATE_ORGANIZATION_PARAMETERS_ROLE(
                                        organizationId,
                                        roleId
                                    )}
                                >
                                    {translate('dupliquer_28256')}
                                </Button>
                            </InlineButton>
                        </Alert.Text>
                    </Alert.Titled>
                </Alert.Root>
            )}
            <InformationBox disabled={disabled} />
            <MembersBox disabled={disabled} />
            <PositionsBox disabled={disabled} />
            <CommunicationBox disabled={disabled} />
            <AccreditationsBox />
            <DelegationsBox />
            {children}
        </Flex>
    );
};

export const RoleFormSkeleton = ({ children }: { children?: React.ReactNode }) => (
    <Flex direction="column" gap="4">
        <InformationSkeletonBox />
        <MembersSkeletonBox />
        <PositionsSkeletonBox />
        <CommunicationSkeletonBox />
        <AccreditationsBox />
        <DelegationsBox />
        {children}
    </Flex>
);
